import client from './config'

//////////////// index_header ////////////////
const url = 'index_header';
export const getIndexHeaderRequest = () => client.get(url);

export const updateIndexHeaderRequest = (values) => client.post(url, values);